window.SpinnerUtils = {
  
  show: function(container, overlayClass = 'spinner-overlay') {
    if (!container) return;
    
    let spinnerOverlay = container.querySelector(`.${overlayClass}`);
    if (!spinnerOverlay) {
      spinnerOverlay = document.createElement('div');
      spinnerOverlay.className = overlayClass;
      spinnerOverlay.innerHTML = '<div class="spinner"></div>';
      
      const mainContainer = container.querySelector('[class*="__container"]') || container;
      mainContainer.appendChild(spinnerOverlay);
    }
    spinnerOverlay.classList.remove('hidden');
  },

  hide: function(container, overlayClass = 'spinner-overlay') {
    if (!container) return;
    
    const spinnerOverlay = container.querySelector(`.${overlayClass}`);
    if (spinnerOverlay) {
      spinnerOverlay.classList.add('hidden');
    }
  },

  showDefault: function(configurator) {
    this.show(configurator, 'spinner-overlay');
  },

  hideDefault: function(configurator) {
    this.hide(configurator, 'spinner-overlay');
  },

  showLineItem: function(drawer) {
    this.show(drawer, 'spinner-overlay');
  },

  hideLineItem: function(drawer) {
    this.hide(drawer, 'spinner-overlay');
  },

  // Metodi generici
  showGeneric: function(container) {
    this.show(container, 'spinner-overlay');
  },

  hideGeneric: function(container) {
    this.hide(container, 'spinner-overlay');
  }
};

// Metodi globali per retrocompatibilità
window.showSpinner = function(container, overlayClass = 'spinner-overlay') {
  window.SpinnerUtils.show(container, overlayClass);
};

window.hideSpinner = function(container, overlayClass = 'spinner-overlay') {
  window.SpinnerUtils.hide(container, overlayClass);
};